var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitlab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 19.7367L14.947 10.6699H9.05614L11.9994 19.7367Z",
    fill: "#E24329"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92752 10.67L4.0299 13.4246C3.94868 13.6747 4.0364 13.9508 4.25079 14.1067L11.9995 19.7367L4.92752 10.67Z",
    fill: "#FCA326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92752 10.67H9.05614L7.2793 5.20952C7.18835 4.93016 6.79203 4.93016 6.69782 5.20952L4.92752 10.67Z",
    fill: "#E24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0757 10.67L19.9701 13.4246C20.0513 13.6747 19.9636 13.9508 19.7492 14.1067L11.9994 19.7367L19.0757 10.67Z",
    fill: "#FCA326"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0757 10.67H14.9471L16.7207 5.20952C16.8116 4.93016 17.2079 4.93016 17.3021 5.20952L19.0757 10.67Z",
    fill: "#E24329"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 19.7367L14.947 10.67H19.0757L11.9994 19.7367Z",
    fill: "#FC6D26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 19.7367L4.92752 10.67H9.05614L11.9994 19.7367Z",
    fill: "#FC6D26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1H20V-1H4V1ZM23 4V20H25V4H23ZM20 23H4V25H20V23ZM1 20V4H-1V20H1ZM4 23C2.34315 23 1 21.6569 1 20H-1C-1 22.7614 1.23858 25 4 25V23ZM23 20C23 21.6569 21.6569 23 20 23V25C22.7614 25 25 22.7614 25 20H23ZM20 1C21.6569 1 23 2.34315 23 4H25C25 1.23858 22.7614 -1 20 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z",
    fill: "#DDDFE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.5f93945fda457a5fb6674e107366e79f.svg";
export { ForwardRef as ReactComponent };